import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DataTableDirective } from 'angular-datatables';
import { CompleterData, CompleterService } from 'ng2-completer';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EmitterService } from 'src/app/services/emitter.service';
import { ConfigurationService } from 'src/app/services/integration-services/configuration.service';
import { MetaDataService } from 'src/app/services/integration-services/metadata.service';
import { WMSService } from 'src/app/services/integration-services/wms.service';

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent implements OnInit {
  language = this.configService.language;
  direction = ((this.language == 'ar') ? "rtl" : "ltr");
  integrationForm: FormGroup
  reqObj: any;
  formObj = this.configService.getGlobalpayload();
  serviceProviders: any = []
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  serviceproviderDescription: any = [];
  providerIDs: CompleterData;
  focusedElement: boolean;
  productHeaderData: any;
  IntegrationDataList: any = []
  deleteInfo: any;
  constructor(private configService: ConfigurationService,
    private metaDataService: MetaDataService,
    private wmsService: WMSService,
    public ngxSmartModalService: NgxSmartModalService,
    private toastr: ToastrService,
    private emitterService: EmitterService,
    private completerService: CompleterService,
    private translate: TranslateService,) {
    this.translate.use(this.language);
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      lengthMenu: [5, 10, 25, 50],
      language: {
        lengthMenu: 'Show _MENU_ Entries',
      }

    };
    this.configService.forLanguage$.subscribe(data => {
      this.language = data;
      this.direction = (this.language == 'ar') ? "rtl" : "ltr";
      this.translate.use(this.language);
    })
    this.createIntegrationForm();
    this.findAllIntegration();
    this.fetchServiceProviders();
  }
  createIntegrationForm() {
    this.integrationForm = new FormBuilder().group({
      status: [null],
      _id: [null],
      loadCreateConfiguration: [null],
      fmsBaseUrl: [null],
      createdDate: [new Date().toISOString().split('T')[0]],
      lastUpdatedDate: [new Date().toISOString().split('T')[0]],
      serviceProviderIDName: [''],
      serviceProviderID: [''],
      serviceProviderName: [''],
      "wareHouseIDName": this.configService.getWarehouse().wareHouseIDName,
      "organizationIDName": this.configService.getOrganization().organizationIDName,
    });
  }
  editId: string | null = null;

  save() {
    const reqObj = this.integrationForm.value;
    const currentDate = new Date().toISOString().split('T')[0];
    const updatedDate = new Date().toISOString().split('T')[0];

    const selectedServiceProvider = this.serviceProviders.find(provider =>
      provider.serviceProviderIDName === reqObj.serviceProviderIDName
    );
    const payload = {
      _id: reqObj._id,
      wareHouseInfo: this.configService.getWarehouse(),
      organizationInfo: this.configService.getOrganization(),
      fmsBaseUrl: reqObj.fmsBaseUrl,
      createdDate: currentDate,
      lastUpdatedDate: updatedDate,
      status: reqObj.status,
      loadCreateConfiguration: reqObj.loadCreateConfiguration,
      serviceProviderInfo: selectedServiceProvider
        ? {
          serviceProviderMasterID: selectedServiceProvider._id,
          serviceProviderID: selectedServiceProvider.serviceProviderID,
          serviceProviderName: selectedServiceProvider.serviceProviderName,
          serviceProviderIDName: selectedServiceProvider.serviceProviderIDName,
        }
        : null
    };
    this.wmsService.saveorUpdateIntegrationData(payload).subscribe(res => {
      if (res.status === 0) {
        this.findAllIntegration();
        this.toastr.success(res.statusMsg);
        this.clear();
      }else {
        this.toastr.error(res.statusMsg);
      }
    });
  }

  edit(data: any) {
    this.integrationForm.patchValue(data)
    this.integrationForm.controls.serviceProviderIDName.setValue(data.serviceProviderInfo.serviceProviderIDName)
    this.ngxSmartModalService.getModal('integrations').close();
    console.log(this.integrationForm.value)
  }

  clear() {
    this.integrationForm.reset();
    this.editId = null;
  }


  // findFmsintegrationByID(){
  //   this.reqObj = this.integrationForm.value
  //   const payload = {
  //     "wareHouseInfo": this.configService.getWarehouse(),
  //     "organizationInfo": this.configService.getOrganization(),     
  //   }

  //   console.log(payload);
  //   this.wmsService.saveorUpdateIntegrationData(payload).subscribe(res => {
  //     if (res['status'] === 0 && res['data']['fmsIntegrationInformation']) {
  //       this.toastr.success("Saved Successfully");
  //       this.clear();
  //     }
  //   })
  // }

  onFocusForElement(element) {
    if (this.focusedElement !== element) {
      this.focusedElement = element;
    }
  }
  onFocusOutForElement() {
    this.focusedElement = undefined;
  }
  shouldShowErrors(fieldName) {
    if (this.focusedElement && this.focusedElement === fieldName) {
      return false;
    } else {
      return fieldName.invalid && fieldName.touched;
    }
  }
  shouldShowSuccess(fieldName) {
    if (this.focusedElement && this.focusedElement === fieldName) {
      return false;
    } else {
      return fieldName.valid && fieldName.touched;
    }
  }

  filteredServiceProviders: string[] = [];

  fetchServiceProviders() {
    this.metaDataService.fetchAllServiceProviders(this.formObj).subscribe(
      (response) => {
        if (response && response.status === 0 && response.data.serviceProviders) {
          this.serviceProviders = response.data.serviceProviders;
          this.filteredServiceProviders = this.serviceProviders.map(provider => provider.serviceProviderIDName);

        } else {
          this.serviceProviders = [];
          this.filteredServiceProviders = [];
        }
      });
  }

  filterServiceProviders(searchText: string) {
    if (!searchText) {
      this.filteredServiceProviders = this.serviceProviders.map(provider => provider.serviceProviderIDName);
    } else {
      this.filteredServiceProviders = this.serviceProviders
        .filter(provider => provider.serviceProviderIDName.toLowerCase().includes(searchText.toLowerCase()))
        .map(provider => provider.serviceProviderIDName);
    }
  }

  getServiceProvideInfo(event: any) {
    let selectedValue = event || '';

    let selectedProvider = this.serviceProviders.find(provider => provider.serviceProviderIDName === selectedValue);

    if (selectedProvider) {
      this.productHeaderData['serviceProviderID'] = selectedProvider.serviceProviderID;
      this.productHeaderData['serviceProviderName'] = selectedProvider.serviceProviderName;
      this.productHeaderData['serviceProviderMasterID'] = selectedProvider._id;
    }
  }
  findAllIntegration() {
    this.IntegrationDataList = []
    this.wmsService.findAllIntegrationData(this.formObj).subscribe(
      (response) => {
        if (response && response.status === 0) {
          if (response.data.fmsIntegrationInformations.length > 0) {
            this.IntegrationDataList = response.data.fmsIntegrationInformations;
            //this.rerender();
          } else {
            this.IntegrationDataList = [];
          }
        } else {
          this.IntegrationDataList = [];
        }
      },
    )
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dtTrigger.next();
      dtInstance.destroy();
    });
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  openModalPopUp() {
    this.findAllIntegration()
    this.ngxSmartModalService.getModal('integrations').open();
  }
  // edit(data: any) {
  //   console.log("Editing Data:", data);

  //   this.integrationForm.patchValue({
  //     fmsBaseUrl: data.fmsBaseUrl,
  //     serviceProviderIDName: data.serviceProviderIDName,
  //     status: data.status,
  //     loadCreateConfiguration: data.loadCreateConfiguration
  //   });
  // }

  delete(data: any) {
    this.deleteInfo = { name: 'integration', id: data._id };
    this.ngxSmartModalService.getModal('deletePopup').open();

  }
  getConfirmation(status) {
    if (status === 'Yes') {
      this.findAllIntegration();
    }
  }
}
